import { getAnonymousJWTTokenKey, getMemberJWTTokenKey } from './getMemberJWTTokenKey.web';
import { setAblyCookie } from './setAblyCookie';
import { removeAblyCookie } from './removeAblyCookie.web';

export const setMemberToken = async (token: string) => {
  const memberJWTTokenKey = await getMemberJWTTokenKey();
  const anonymousJWTTokenKey = await getAnonymousJWTTokenKey();

  await setAblyCookie(memberJWTTokenKey, token);
  removeAblyCookie(anonymousJWTTokenKey);

  // TODO: amplitude setUserId 호출 (로깅 SDK 유저 식별)
};
